import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [subscription, setSubscription] = useState(null);

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      refreshSubscription();
    } catch {
      setUser(false);
    }
  };

  const refreshSubscription = async () => {
    try {
      const { data } = await api.get("/subscription");
      setSubscription(data);
    } catch {
      /* noop */
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) loadMe();
    else setUser(false);
  }, []);

  const login = (userObj, token) => {
    localStorage.setItem("token", token);
    setUser(userObj);
    refreshSubscription();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("token");
    setUser(false);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, subscription, refreshSubscription, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
